import { Component, OnInit, inject } from '@angular/core';
import {CsatPrivacyComponent} from "./csat/csat-privacy/csat-privacy.component";
import {ModalService} from "@shared";
import {CsatService, FeatureFlags, FeatureFlagService} from "@core";
import {Observable} from "rxjs";

@Component({
    selector: 'app-feedback',
    templateUrl: './feedback.component.html',
    styleUrls: ['./feedback.component.scss'],
    standalone: false
})
export class FeedbackComponent implements OnInit{
    private readonly modalService = inject(ModalService);
    private readonly featureFlagService = inject(FeatureFlagService);
    private readonly csatService = inject(CsatService);


    public selectedTab = 0;

    public reportIssueEnabled: Observable<boolean>;

    ngOnInit() {
        this.reportIssueEnabled = this.featureFlagService.isEnabled(FeatureFlags.ReportIssueTab);
    }

    public onTabSelected(tabIndex: number): void {
        this.selectedTab = tabIndex;
    }

    public openPrivacyModal(): void {
        this.modalService.openCustomModal(CsatPrivacyComponent, () => {}, null, null, true);
    }

    public dismissModal() {
        this.csatService.enableCsat(false);
    }
}
